import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const DownloadIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <path className={classes.element} d="M2,18v2a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V18" />
      <line className={classes.element} x1="12" y1="2.00001" x2="12" y2="16.00001" />
      <polyline className={classes.element} points="6 10 12 16 18 10" />
    </svg>
  );
};
export default DownloadIcon;
